import React from 'react';

/**
 * Renders a translated sentence that contains React nodes — a link, a coloured
 * amount — by splitting the ONE translated string on its `{placeholders}`.
 *
 * This exists so a sentence is never assembled from two translated fragments:
 * word order differs between languages, and concatenation quietly hard-codes
 * English order. The translator gets the whole sentence and decides where the
 * placeholders go (spec I18N-01 AC-04).
 *
 * Shared by the wallet setup wizard and the live instructor onboarding screen
 * so the agreement sentence is rendered the same way on both.
 */
export function interpolateNodes(
  template: string,
  values: Record<string, React.ReactNode>,
): React.ReactNode[] {
  const names = Object.keys(values);
  if (names.length === 0) return [template];

  const pattern = new RegExp(`(${names.map((name) => `\\{${name}\\}`).join('|')})`, 'g');

  return template.split(pattern).map((chunk, index) => {
    const name = chunk.startsWith('{') && chunk.endsWith('}') ? chunk.slice(1, -1) : null;
    const node = name !== null && name in values ? values[name] : chunk;
    return <React.Fragment key={index}>{node}</React.Fragment>;
  });
}
